import { getBaseInterfaceInfo, runSweeping, getExperimentResult, getExperimentMarginResult, getExperimentAdjustResult } from '../api/Rocky/experimentCtrl';
import { getExperimentGroup, editExperimentGroup, deleteExperimentGroup, getExperiments, editExperiment, deleteExperiment, deleteExperiments, postExperimentColumns, getExperimentsResultExsit } from '../api/v2/experimentCtrl'
import apiProcess from '../api/utility';

const ROCKY = 'Rocky';

// 获取sweep list
export function getExperimentGroupPromise(verificationId) {
  return apiProcess(getExperimentGroup, { verificationId })
}

export function editExperimentGroupPromise({ id = "", name, version, verificationId }) {
  return apiProcess(editExperimentGroup, { data: { id, name, version, verificationId }, product: ROCKY })
}

export function deleteExperimentGroupPromise({ experimentGroupId }) {
  return apiProcess(deleteExperimentGroup, { experimentGroupId })
}

// sweep data

// get experiment list
export function getExperimentListPromise({ experimentGroupId }) {
  return apiProcess(getExperiments, { experimentGroupId })
};

// Edit Exp and add Exp function
export function editExperimentPromise(params) {
  return apiProcess(editExperiment, { params, product: ROCKY })
}

// 删除Exp
// export function deleteExperimentPromise(experimentId) {
//   return apiProcess(deleteExperiment, experimentId)
// }

export function deleteExperimentByIds(deleteArr) {
  return apiProcess(deleteExperiments, deleteArr)
}

// get base data
export function getBaseInterfaceInfoPromise(verificationId) {
  return apiProcess(getBaseInterfaceInfo, verificationId)
};

// edit tableColumns data
export function saveSweepColumnsPromise({ id, tableColumns }) {
  return apiProcess(postExperimentColumns, { id, tableColumns })
}

// run sweep
// runSweepingPromise
export function runSweepingPromise(experimentIds) {
  return apiProcess(runSweeping, { experimentIds }, false, true)
}

// result
// get sweep expList
export function getExperimentsResultExistPromise({ experimentGroupId }) {
  return apiProcess(getExperimentsResultExsit, { experimentGroupId })
}

// get exp content
export function getExperimentResultPromise({ verificationId, signalGroup, option, type, signal, componentName }) {
  return new Promise((resolve, reject) => {
    getExperimentResult({ verificationId, signalGroup, option, type, signal, componentName }).then(res => {
      if (res && res.data) {
        resolve(res.data);
      } else {
        resolve(null);
      }
    }, error => {
      console.error(error);
      resolve(null);
    });
  });
}

//Obtain the data of the result eye diagram in the specific exp
export function getExperimentMarginResultPromise({ verificationIds, type, signalGroup }) {
  return apiProcess(getExperimentMarginResult, { verificationIds, type, signalGroup });
}

export function getExperimentAdjustResultPromise({ verificationId, signalGroup }) {
  return apiProcess(getExperimentAdjustResult, { verificationId, signalGroup });
}